import { getUserDetail } from 'api/user/user.query'
import { t } from 'i18next'
import { redirect } from 'react-router-dom'
import { showToaster } from 'shared/components/toaster/helper'
import allRoutes from 'shared/lib/allRoutes'
import { isUserLoggedIn, userLogOut } from 'shared/lib/user'
import { clearStorage, navigationTo } from 'shared/utils'

export const privateLoader = (queryClient) => async () => {
  const token = isUserLoggedIn()

  if (token) {
    try {
      const { data: user } = await queryClient.fetchQuery({ queryKey: ['getUserDetail'], queryFn: getUserDetail })

      return {
        token: token || null,
        user: user?.data,
        permissions: user?.data?.aPermissions || []
      }
    } catch (error) {
      if (error.status === 401 || error.status === 400) {
        clearStorage('token')
        userLogOut()
        navigationTo('/login')
        showToaster({ msg: t('permissionDenied'), eType: 'w' })
        return redirect(`/?from=${window.location.pathname}${window.location.search || ''}`)
      }
      return null
    }
  } else {
    // return null
    return redirect(`/?from=${window.location.pathname}${window.location.search || ''}`)
  }
}

export const publicLoader = async () => {
  if (isUserLoggedIn()) return redirect(allRoutes.settings)
  else return null
}
